/**
 * Pricing Page
 * Pricing tiers and value comparison
 */

import { PricingSection } from '@/components/sections/pricing';
import { ComparisonSection } from '@/components/sections/comparison';
import { CtaSection } from '@/components/sections/cta';

export function PricingPage() {
  return (
    <>
      <div className="pt-24">
        <div className="max-w-4xl mx-auto px-4 py-16 text-center">
          <div className="backdrop-blur-md bg-background/60 border border-border/50 rounded-2xl p-8 md:p-12 shadow-xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Simple, Transparent Pricing</h1>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              Start with Spark and upgrade as caching, compression, and routing needs grow.
            </p>
          </div>
        </div>
      </div>
      <PricingSection />
      <ComparisonSection />
      <CtaSection />
    </>
  );
}
